// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"238":"ef6a991d","362":"453f102a"}[chunkId] + ".js";
};